import FqApi from '@/services/fq-api'

const baseUrl = '/ormmessages'
const ormServiceBaseUrl = '/ormservice'

export default {
  async getOrmQuoteStatusTypes() {
    const result = await FqApi.get(`${baseUrl}/quotestatustypes`)
    return result.data
  },
  async testConnection() {
    const result = await FqApi.get(`${ormServiceBaseUrl}/testconnection`)
    return result
  },
  async sendQdeVersionChange(repairerId, ormQdeVersion) {
    const result = await FqApi.post(`${ormServiceBaseUrl}/qdeversionchange/${repairerId}/${ormQdeVersion}`)
    return result
  },
  async getOrmQdeVersion() {
    const result = await FqApi.get(`${ormServiceBaseUrl}/getormqdeversion`)
    return result.data
  },
  async getMessages(claimNo, rego, messageType) {
    const result = await FqApi.get(`${baseUrl}/messages`, {
      params: {
        claimNo,
        rego,
        messageType
      }
    })
    return result.data
  }
}